import { NgModule } from "@angular/core";
import { MatRippleModule } from "@angular/material/core";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatToolbarModule } from "@angular/material/toolbar";
import { CommonModule } from "@angular/common";
import { PhoenixPipesModule } from "app/pipes/pipes";
import { PhoenixDirectivesModule } from "app/directives/directives.module";
import { UserManagementUserComponent } from "./user-management-user.component";
import { ValidationErrorsModule } from "app/components/validation-errors/validation-errors.module";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";

@NgModule({
    declarations: [UserManagementUserComponent],
    imports: [
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatRippleModule,
        MatInputModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDialogModule,
        MatToolbarModule,
        MatAutocompleteModule,
        MatTooltipModule,
        MatDividerModule,
        MatTabsModule,
        CommonModule,
        FuseSharedModule,
        PhoenixPipesModule,
        PhoenixDirectivesModule,
        ValidationErrorsModule,
    ],
    exports: [],
    providers: []
})
export class UserManagementUserModule{}
